export default __webpack_public_path__ + "static/media/iCal-calendar.cb75eba4.png";